import { render, staticRenderFns } from "./PoliticaDePrivacidade.vue?vue&type=template&id=b8af4376&scoped=true"
import script from "./PoliticaDePrivacidade.vue?vue&type=script&lang=js"
export * from "./PoliticaDePrivacidade.vue?vue&type=script&lang=js"
import style0 from "./PoliticaDePrivacidade.vue?vue&type=style&index=0&id=b8af4376&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8af4376",
  null
  
)

export default component.exports